
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/LeanDatePicker/LeanDatePicker.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./LeanDatePicker.html');
        
        var script = require('./LeanDatePicker.ts').default;
        module.exports = require('./LeanDatePicker.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    